import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/network/page.tsx");
